import "../scss/main.scss";

document.addEventListener("DOMContentLoaded", () => {
  const list = document.querySelector(".wp-block-categories");
  if (!list) return;

  // =========================
  // 🔥 WSZYSTKIE
  // =========================
  const allItem = document.createElement("li");
  allItem.className = "cat-item nt-all";

  const wrapperAll = document.createElement("div");
  wrapperAll.className = "nt-cat";

  const allLink = document.createElement("a");
  allLink.href = window.location.origin + "/sklep/";
  allLink.textContent = wp.i18n.__("Wszystkie", "astra-child");

  // 🔥 AKTYWNY gdy dokładnie /sklep/
  const path = window.location.pathname.replace(/\/$/, "");

  if (path === "/sklep") {
    wrapperAll.classList.add("is-active");
  }

  wrapperAll.appendChild(allLink);
  allItem.appendChild(wrapperAll);
  list.prepend(allItem);

  // =========================
  // 🔥 KATEGORIE
  // =========================
  document
    .querySelectorAll(".wp-block-categories .cat-item")
    .forEach((item) => {
      const link = item.querySelector(":scope > a");
      if (!link) return;

      const children = item.querySelector(":scope > .children");
      const hasChildren = !!children;

      // count
      let count = "";
      item.childNodes.forEach((node) => {
        if (node.nodeType === 3) {
          const match = node.textContent.match(/\((\d+)\)/);
          if (match) count = match[1];
        }
      });

      const isCurrent =
        item.classList.contains("current-cat") ||
        item.classList.contains("current-cat-parent") ||
        item.classList.contains("current-cat-ancestor");

      const wrapper = document.createElement("div");
      wrapper.className = "nt-cat";

      if (isCurrent) {
        wrapper.classList.add("is-active");
      }

      // =========================
      // 🔥 CHILD → checkbox
      // =========================
      if (!hasChildren) {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "nt-cat__checkbox";
        checkbox.checked = isCurrent;

        checkbox.addEventListener("change", () => {
          if (checkbox.checked) {
            window.location.href = link.href;
            return;
          }

          // 🔥 bazujemy na URL zamiast DOM (pewne rozwiązanie)
          const url = new URL(window.location.href);

          let path = url.pathname.replace(/\/$/, ""); // usuń trailing slash

          const parts = path.split("/").filter(Boolean);

          // 🔥 jeśli jesteśmy w child → usuń ostatni segment
          if (parts.length > 1) {
            parts.pop();
            window.location.href = "/" + parts.join("/") + "/";
            return;
          }

          // 🔥 jeśli jesteśmy na poziomie parent → idź do sklepu
          window.location.href = window.location.origin + "/sklep/";
        });

        wrapper.appendChild(checkbox);
      }

      // =========================
      // 🔥 LINK (nie blokujemy!)
      // =========================
      link.classList.add("nt-cat__name");

      // count
      const countEl = document.createElement("span");
      countEl.className = "nt-cat__count";
      countEl.textContent = count ? `(${count})` : "";

      // usuń "(3)"
      item.childNodes.forEach((node) => {
        if (node.nodeType === 3) node.textContent = "";
      });

      // składanie
      item.insertBefore(wrapper, link);
      wrapper.appendChild(link);
      wrapper.appendChild(countEl);
    });
  list.classList.add("is-ready");
});

/// fix add to cart homepage
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("wc-blocks_added_to_cart", function () {
    try {
      // 🔥 symulujemy klasyczny Woo event
      if (window.jQuery) {
        window.jQuery(document.body).trigger("added_to_cart", [{}, {}, null]);
      }

      // 🔥 fallback (niektóre theme tego słuchają)
      document.body.dispatchEvent(new Event("added_to_cart"));
    } catch (e) {
      console.warn("Trigger added_to_cart failed", e);
    }
  });
});

jQuery(function ($) {
  $("form.checkout").on("checkout_place_order", function () {
    const method = $('input[name="payment_method"]:checked').val();

    if (method === "p24-online-payments") {
      const checkbox = $("#p24-online-payments-regulation-checkbox_0");

      if (!checkbox.is(":checked")) {
        alert("Musisz zaakceptować regulamin Przelewy24.");
        return false;
      }
    }

    return true;
  });
});
